import fpClickOutside from './fpClickOutside'

export default [
  { name: 'fpClickOutside', value: fpClickOutside }
]
